import { useNavigate } from "react-router-dom";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/solid";

export default function StickyChatButton() {
  const navigate = useNavigate();

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 flex justify-center"
      style={{
        paddingBottom: "calc(var(--safe-area-inset-bottom) )", // safe area   + 0.75rem
        paddingTop: "0.75rem",
      }}
    >
      {/* Gradient strip */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />

      {/* Rounded button */}
      <button
        onClick={() => navigate("/chat")}
        className="w-full relative z-10 flex justify-center items-center gap-2 mx-4 px-6 py-3 bg-sage text-white rounded-3xl shadow-lg transform transition-transform duration-200 hover:scale-105"
      >
        <ChatBubbleLeftIcon className="w-6 h-6 text-white" />
        <span>Chat with Sous</span>
      </button>
    </div>
  );
}
